(function () {
  function parseVariants(dropdown) {
    const script =
      dropdown.closest("[data-variant-picker]") &&
      dropdown.closest("[data-variant-picker]").querySelector("#productVariants");
    if (!script) return [];

    try {
      return JSON.parse(script.textContent || "[]");
    } catch (error) {
      return [];
    }
  }

  function syncTrigger(dropdown) {
    const checked = dropdown.querySelector("input[type='radio']:checked");
    const option = checked && checked.closest("[data-flavour-option]");
    if (!option) return;

    const swatch = dropdown.querySelector("[data-dropdown-swatch]");
    const copy = dropdown.querySelector(".purchase-selector__dropdown-copy");
    let badge = dropdown.querySelector("[data-dropdown-badge]");
    const badgeText = option.dataset.badge || "";

    if (swatch) {
      swatch.style.backgroundColor = option.dataset.swatch || "";
      swatch.style.backgroundImage = option.dataset.swatchImage
        ? "url(" + option.dataset.swatchImage + ")"
        : "";
    }

    if (!badgeText) {
      if (badge) badge.remove();
    } else if (badge) {
      badge.hidden = false;
      badge.textContent = badgeText;
    } else if (copy) {
      badge = document.createElement("span");
      badge.className = "purchase-selector__pill apercu";
      badge.setAttribute("data-dropdown-badge", "");
      badge.textContent = badgeText;
      copy.appendChild(badge);
    }
  }

  function priceBasisMap() {
    const script = document.getElementById("variantPriceBasis");
    if (!script) return {};

    try {
      return JSON.parse(script.textContent || "{}");
    } catch (error) {
      return {};
    }
  }

  function syncPackDiscounts(dropdown) {
    const flavourIndex = Number(dropdown.dataset.flavourIndex);
    const sizeIndex = Number(dropdown.dataset.sizeIndex);
    if (Number.isNaN(sizeIndex) || sizeIndex < 0) return;

    const variants = parseVariants(dropdown);
    const basisMap = priceBasisMap();
    const flavourInput = dropdown.querySelector("input[type='radio']:checked");
    const flavourName = flavourInput ? flavourInput.value : null;

    document.querySelectorAll(".purchase-selector__pack.variant-picker__option").forEach((pack) => {
      const sizeValue = pack.dataset.value;
      const match = variants.find((variant) => {
        const options = variant.options || [];
        if (options[sizeIndex] !== sizeValue) return false;
        if (flavourIndex >= 0 && flavourName && options[flavourIndex] !== flavourName) {
          return false;
        }
        return true;
      });
      if (!match) return;

      const entry = basisMap[match.id] || basisMap[String(match.id)] || {};
      const hasDiscount = entry.discount != null && entry.discount !== "";
      const amount = Number(hasDiscount ? entry.discount : pack.dataset.fallbackDiscountAmount) || 0;
      pack.dataset.discountAmount = String(amount);

      let badge = pack.querySelector(".purchase-selector__badge");
      if (amount > 0) {
        if (!badge) {
          badge = document.createElement("span");
          badge.className = "purchase-selector__badge apercu";
          pack.insertBefore(badge, pack.firstChild);
        }
        badge.textContent = "Save " + Math.round(amount) + "%";
      } else if (badge) {
        badge.remove();
      }
    });
  }

  function closeDropdown(dropdown) {
    if (dropdown && dropdown.tagName === "DETAILS") {
      dropdown.removeAttribute("open");
    }
  }

  document.addEventListener("change", function (event) {
    const dropdown = event.target.closest("[data-flavour-dropdown]");
    if (dropdown && event.target.matches("input[type='radio']")) {
      syncTrigger(dropdown);
      syncPackDiscounts(dropdown);
      closeDropdown(dropdown);
    }
  });

  document.addEventListener("click", function (event) {
    document.querySelectorAll("details[data-flavour-dropdown][open]").forEach((dropdown) => {
      if (!dropdown.contains(event.target)) {
        closeDropdown(dropdown);
      }
    });
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    document.querySelectorAll("details[data-flavour-dropdown][open]").forEach(closeDropdown);
  });
})();
